


import { CSVLink } from 'react-csv';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllUsersAction } from '../../redux/Started/apisActions';
import { toast, Bounce } from 'react-toastify';

function formatQAValue(val) {
  if (typeof val === 'boolean') {
    return val ? 'Yes' : 'No';
  }
  return val === '' || val === null || val === undefined ? '' : String(val);
}

function flattenQuestions(data, parentKey = '', result = { questions: [], answers: [] }) {
  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      if (typeof item === 'object' && item !== null) {
        flattenQuestions(item, `${parentKey}[${index}]`, result);
      } else {
        result.questions.push(parentKey || `item[${index}]`);
        result.answers.push(formatQAValue(item));
      }
    });
  } else if (typeof data === 'object' && data !== null) {
    Object.entries(data).forEach(([key, value]) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        flattenQuestions(value, fullKey, result);
      } else if (Array.isArray(value)) {
        flattenQuestions(value, fullKey, result);
      } else {
        result.questions.push(fullKey);
        result.answers.push(formatQAValue(value));
      }
    });
  } else {
    result.questions.push(parentKey || '');
    result.answers.push(formatQAValue(data));
  }
  return result;
}

function getLevelQA(levelData) {
  if (!levelData || (typeof levelData === 'object' && Object.keys(levelData).length === 0)) {
    return { questions: [''], answers: [''] };
  }
  const { questions, answers } = flattenQuestions(levelData);
  if (questions.length === 0) return { questions: [''], answers: [''] };
  return { questions, answers };
}

const LEVELS = [
  { key: 'levelOne', label: 'Level 1' },
  { key: 'levelTwo', label: 'Level 2' },
  { key: 'levelThree', label: 'Level 3' },
  { key: 'levelFour', label: 'Level 4' },
  { key: 'levelFive', label: 'Level 5' },
  { key: 'levelSix', label: 'Level 6' },
  { key: 'levelSeven', label: 'Level 7' },
];

const Table = ({ headers, data, page }) => {
  const [csvData, setCsvData] = useState(null);
  const dispatch = useDispatch();
  const csvLinkRef = useRef(null);
  const { allUsers, loading, error } = useSelector((state) => state.initialUserInfo);

  console.log('Table data prop:', data);
  console.log('Redux allUsers before fetch:', allUsers);
  console.log('Redux error:', error);

  const getAllCsv = async () => {
    const token = localStorage.getItem('token');
    console.log('Token:', token);
    if (!token) {
      toast.error('Please log in to export CSV.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Bounce,
      });
      window.location.href = '/login';
      return;
    }

    try {
      console.log('Dispatching fetchAllUsersAction');
      const result = await dispatch(fetchAllUsersAction()).unwrap();
      console.log('API response:', result);
      const users = Array.isArray(result) ? result : result.users || [];
      console.log('Processed users:', users);
      if (!users || users.length === 0) {
        console.log('No users found in response');
        toast.warn('No user data available to export.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Bounce,
        });
        return;
      }
      const generatedCsvData = generateCSVData(users);
      console.log('Generated CSV data:', generatedCsvData);
      setCsvData(generatedCsvData);
    } catch (err) {
      console.error('Error fetching users:', {
        message: err.message,
        stack: err.stack,
        details: err,
      });
      toast.error(`Failed to fetch data for CSV export: ${err.message || 'Unknown error'}`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (csvData && csvLinkRef.current) {
      if (!Array.isArray(csvData)) {
        console.error('Invalid csvData format:', csvData);
        toast.error('Invalid CSV data format. Please try again.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          transition: Bounce,
        });
        return;
      }
      console.log('Triggering CSV download with data:', csvData);
      csvLinkRef.current.link.click();
      setCsvData(null);
    }
  }, [csvData]);






// Helper function to recursively remove _id from objects and arrays
// const removeIdFields = (obj) => {
//   if (Array.isArray(obj)) {
//     return obj.map(item => removeIdFields(item));
//   } else if (obj && typeof obj === 'object') {
//     const newObj = {};
//     for (const key of Object.keys(obj)) {
//       if (key !== '_id' && key !== 'id') {
//         newObj[key] = removeIdFields(obj[key]);
//       }
//     }
//     return newObj;
//   } else if (typeof obj === 'string') {
//     return obj.toLowerCase().includes('id') ? '' : obj;
//   }
//   return obj;
// };

// // Helper function to check if a question should be excluded
// const shouldExcludeQuestion = (question) => {
//   const lowerQuestion = question.toLowerCase();
//   return (
//     lowerQuestion.includes('id') || // Exclude any question with 'id' or '_id'
//     /strengths\[\d+\]>value/.test(lowerQuestion) || // Exclude strengths[X]>value
//     lowerQuestion.endsWith('>value') // Exclude any question ending with >value
//   );
// };

// const generateCSVData = (users) => {
//   if (!Array.isArray(users)) {
//     console.error('generateCSVData: users is not an array:', users);
//     throw new Error('Invalid users data: Expected an array');
//   }

//   // Get all unique questions from all levels across all users
//   const allLevelQuestions = {};
//   LEVELS.forEach(level => {
//     allLevelQuestions[level.key] = new Set();
//   });

//   // Collect all unique questions for each level
//   users.forEach(user => {
//     LEVELS.forEach(level => {
//       // Deep clean level data to remove _id and id fields
//       const levelData = removeIdFields({ ...user[level.key] });
//       delete levelData.user;
//       delete levelData.createdAt;
//       delete levelData.updatedAt;
//       const { questions } = getLevelQA(levelData);

//       questions.forEach(q => {
//         if (q && q.trim() && !shouldExcludeQuestion(q)) {
//           const modifiedQuestion = q.replace(/\./g, '>');
//           allLevelQuestions[level.key].add(modifiedQuestion);
//         }
//       });
//     });
//   });

//   // Convert sets to arrays and ensure consistent ordering
//   const levelQuestionsArrays = {};
//   LEVELS.forEach(level => {
//     levelQuestionsArrays[level.key] = Array.from(allLevelQuestions[level.key]);
//   });

//   // Create base headers, excluding _id and id
//   const baseHeaders = [
//     'ID',
//     'Datum & Uhrzeit',
//     ...headers.filter(h => !h.key.toLowerCase().includes('id')).map(h => h.label),
//     'Geburtsland',
//     'Vater Geburtsland',
//     'Mutter Geburtsland',
//     'Avatar',
//     'Psychiatrischer Behandlung',
//     'Psychiatrische Diagnose',
//     'Psychologischer Betreuung',
//     'Psychotherapie Behandlung',
//     'Krankenhaus Betreuung',
//     'Diagnosen',
//     'Andere Diagnose',
//     'Medikamenteneinnahme',
//     'Welche Medikamente',
//   ];

//   // Create level header row
//   const levelHeaderRow = [
//     ...baseHeaders.map(() => ''),
//   ];

//   // Create question header row
//   const questionHeaderRow = [...baseHeaders];

//   // Add level headers and questions
//   LEVELS.forEach(level => {
//     const questions = levelQuestionsArrays[level.key];
//     if (questions.length === 0) {
//       levelHeaderRow.push(`*** ${level.label} ***`);
//       questionHeaderRow.push('');
//     } else {
//       questions.forEach((question, index) => {
//         if (index === 0) {
//           levelHeaderRow.push(`*** ${level.label} ***`);
//         } else {
//           levelHeaderRow.push('');
//         }
//         questionHeaderRow.push(question || '');
//       });
//     }
//   });

//   // Create data rows
//   const dataRows = users.map((user, userIndex) => {
//     const userData = removeIdFields({ ...user });

//     const baseRow = [
//       userIndex + 1,
//       userData.createdAt ? format(new Date(userData.createdAt), 'dd/MM/yyyy h:mm a', { locale: de }) : '',
//       ...headers.filter(h => !h.key.toLowerCase().includes('id')).map((h) => {
//         const value = userData[h.key];
//         if (h.key === 'gender') {
//           return value === 'MALE'
//             ? 'Männlich'
//             : value === 'FEMALE'
//             ? 'Weiblich'
//             : value === 'OTHER'
//             ? 'Divers'
//             : value === 'UNKNOWN'
//             ? 'Unbekannt'
//             : '';
//         }
//         return value || '';
//       }),
//       userData.birthPlace?.country || '',
//       userData.birthPlace?.fatherCountry || '',
//       userData.birthPlace?.motherCountry || '',
//       userData.avatar || '',
//       userData.psychiatricCare || '',
//       userData.psychiatricDiagnosis || '',
//       userData.psychologicalCare || '',
//       userData.psychotherapy || '',
//       userData.hospitalCare || '',
//       Array.isArray(userData.diagnoses) ? userData.diagnoses.join(', ') : '',
//       userData.otherDiagnosis || '',
//       typeof userData.isTakingMedication === 'boolean' ? (userData.isTakingMedication ? 'Ja' : 'Nein') : '',
//       userData.whichTakeMedication || '',
//     ];

//     // Add answers for each level
//     LEVELS.forEach(level => {
//       const levelData = removeIdFields({ ...userData[level.key] });
//       delete levelData.user;
//       delete levelData.createdAt;
//       delete levelData.updatedAt;
//       const { questions, answers } = getLevelQA(levelData);
//       const levelQuestions = levelQuestionsArrays[level.key];

//       if (levelQuestions.length === 0) {
//         baseRow.push('');
//       } else {
//         const questionAnswerMap = {};
//         questions.forEach((q, index) => {
//           if (!shouldExcludeQuestion(q)) {
//             const modifiedQuestion = q.replace(/\./g, '>');
//             questionAnswerMap[modifiedQuestion] = removeIdFields(answers[index]) || '';
//           }
//         });

//         levelQuestions.forEach(question => {
//           baseRow.push(questionAnswerMap[question] || '');
//         });
//       }
//     });

//     return baseRow;
//   });

//   // Combine all rows: level headers, question headers, then data
//   const csvData = [levelHeaderRow, questionHeaderRow, ...dataRows];

//   return csvData;
// };




// const removeIdFields = (obj) => {
//   if (Array.isArray(obj)) {
//     return obj.map(item => removeIdFields(item));
//   } else if (obj && typeof obj === 'object') {
//     const newObj = {};
//     for (const key of Object.keys(obj)) {
//       if (key !== '_id' && key !== 'id') {
//         newObj[key] = removeIdFields(obj[key]);
//       }
//     }
//     return newObj;
//   } else if (typeof obj === 'string') {
//     return obj.toLowerCase().includes('id') ? '' : obj;
//   }
//   return obj;
// };

// // Helper function to check if a question should be excluded
// const shouldExcludeQuestion = (question) => {
//   const lowerQuestion = question.toLowerCase();
//   return (
//     lowerQuestion.includes('id') || // Exclude any question with 'id' or '_id'
//     /strengths\[\d+\]>value/.test(lowerQuestion) || // Explicitly exclude strengths[X]>value
//     lowerQuestion.endsWith('>value') || // Exclude any question ending with >value
//     lowerQuestion.includes('value') // Additional check to catch any 'value' fields
//   );
// };

// const generateCSVData = (users) => {
//   if (!Array.isArray(users)) {
//     console.error('generateCSVData: users is not an array:', users);
//     throw new Error('Invalid users data: Expected an array');
//   }

//   // Get all unique questions from all levels across all users
//   const allLevelQuestions = {};
//   LEVELS.forEach(level => {
//     allLevelQuestions[level.key] = new Set();
//   });

//   // Collect all unique questions for each level
//   users.forEach(user => {
//     LEVELS.forEach(level => {
//       // Deep clean level data to remove _id and id fields
//       const levelData = removeIdFields({ ...user[level.key] });
//       delete levelData.user;
//       delete levelData.createdAt;
//       delete levelData.updatedAt;
//       const { questions } = getLevelQA(levelData);

//       questions.forEach(q => {
//         if (q && q.trim() && !shouldExcludeQuestion(q)) {
//           // Replace dots with '>' for consistency
//           const modifiedQuestion = q.replace(/\./g, '>');
//           // Additional check for level 5 to exclude 'strengths' explicitly
//           if (level.key === 'level5' && modifiedQuestion.toLowerCase().includes('strengths')) {
//             return; // Skip adding strengths-related questions in level 5
//           }
//           allLevelQuestions[level.key].add(modifiedQuestion);
//         }
//       });
//     });
//   });

//   // Convert sets to arrays and ensure consistent ordering
//   const levelQuestionsArrays = {};
//   LEVELS.forEach(level => {
//     levelQuestionsArrays[level.key] = Array.from(allLevelQuestions[level.key]).sort();
//   });

//   // Create base headers, excluding _id and id
//   const baseHeaders = [
//     'ID',
//     'Datum & Uhrzeit',
//     ...headers.filter(h => !h.key.toLowerCase().includes('id')).map(h => h.label),
//     'Geburtsland',
//     'Vater Geburtsland',
//     'Mutter Geburtsland',
//     'Avatar',
//     'Psychiatrischer Behandlung',
//     'Psychiatrische Diagnose',
//     'Psychologischer Betreuung',
//     'Psychotherapie Behandlung',
//     'Krankenhaus Betreuung',
//     'Diagnosen',
//     'Andere Diagnose',
//     'Medikamenteneinnahme',
//     'Welche Medikamente',
//   ];

//   // Create level header row
//   const levelHeaderRow = [
//     ...baseHeaders.map(() => ''),
//   ];

//   // Create question header row
//   const questionHeaderRow = [...baseHeaders];

//   // Add level headers and questions
//   LEVELS.forEach(level => {
//     const questions = levelQuestionsArrays[level.key];
//     if (questions.length === 0) {
//       levelHeaderRow.push(`*** ${level.label} ***`);
//       questionHeaderRow.push('');
//     } else {
//       questions.forEach((question, index) => {
//         if (index === 0) {
//           levelHeaderRow.push(`*** ${level.label} ***`);
//         } else {
//           levelHeaderRow.push('');
//         }
//         questionHeaderRow.push(question || '');
//       });
//     }
//   });

//   // Create data rows
//   const dataRows = users.map((user, userIndex) => {
//     const userData = removeIdFields({ ...user });

//     const baseRow = [
//       userIndex + 1,
//       userData.createdAt ? format(new Date(userData.createdAt), 'dd/MM/yyyy h:mm a', { locale: de }) : '',
//       ...headers.filter(h => !h.key.toLowerCase().includes('id')).map((h) => {
//         const value = userData[h.key];
//         if (h.key === 'gender') {
//           return value === 'MALE'
//             ? 'Männlich'
//             : value === 'FEMALE'
//             ? 'Weiblich'
//             : value === 'OTHER'
//             ? 'Divers'
//             : value === 'UNKNOWN'
//             ? 'Unbekannt'
//             : '';
//         }
//         return value || '';
//       }),
//       userData.birthPlace?.country || '',
//       userData.birthPlace?.fatherCountry || '',
//       userData.birthPlace?.motherCountry || '',
//       userData.avatar || '',
//       userData.psychiatricCare || '',
//       userData.psychiatricDiagnosis || '',
//       userData.psychologicalCare || '',
//       userData.psychotherapy || '',
//       userData.hospitalCare || '',
//       Array.isArray(userData.diagnoses) ? userData.diagnoses.join(', ') : '',
//       userData.otherDiagnosis || '',
//       typeof userData.isTakingMedication === 'boolean' ? (userData.isTakingMedication ? 'Ja' : 'Nein') : '',
//       userData.whichTakeMedication || '',
//     ];

//     // Add answers for each level
//     LEVELS.forEach(level => {
//       const levelData = removeIdFields({ ...userData[level.key] });
//       delete levelData.user;
//       delete levelData.createdAt;
//       delete levelData.updatedAt;
//       const { questions, answers } = getLevelQA(levelData);
//       const levelQuestions = levelQuestionsArrays[level.key];

//       if (levelQuestions.length === 0) {
//         baseRow.push('');
//       } else {
//         const questionAnswerMap = {};
//         questions.forEach((q, index) => {
//           if (!shouldExcludeQuestion(q)) {
//             const modifiedQuestion = q.replace(/\./g, '>');
//             // Additional check for level 5 to exclude 'strengths'
//             if (level.key === 'level5' && modifiedQuestion.toLowerCase().includes('strengths')) {
//               return; // Skip strengths-related questions in level 5
//             }
//             questionAnswerMap[modifiedQuestion] = removeIdFields(answers[index]) || '';
//           }
//         });

//         levelQuestions.forEach(question => {
//           baseRow.push(questionAnswerMap[question] || '');
//         });
//       }
//     });

//     return baseRow;
//   });

//   // Combine all rows: level headers, question headers, then data
//   const csvData = [levelHeaderRow, questionHeaderRow, ...dataRows];

//   return csvData;
// };


const removeIdFields = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(item => removeIdFields(item));
  } else if (obj && typeof obj === 'object') {
    const newObj = {};
    for (const key of Object.keys(obj)) {
      if (key !== '_id' && key !== 'id') {
        newObj[key] = removeIdFields(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
};

// Helper function to check if a question should be excluded
const shouldExcludeQuestion = (question) => {
  const lowerQuestion = question.toLowerCase();
  return (
    lowerQuestion === 'id' || // Only exclude exact 'id' or '_id'
    lowerQuestion === '_id' ||
    /strengths\[\d+\](?:\.|>)value/.test(lowerQuestion) || // Explicitly exclude strengths[X].value or strengths[X]>value
    lowerQuestion.endsWith('>value') // Exclude questions ending with >value
  );
};
const getLevelQA = (levelData) => {
  const questions = [];
  const answers = [];

  // Helper function to flatten nested objects/arrays
  const flattenData = (data, prefix = '') => {
    if (Array.isArray(data)) {
      // Handle arrays
      data.forEach((item, index) => {
        const newPrefix = `${prefix}[${index}]`;
        flattenData(item, newPrefix);
      });
    } else if (data && typeof data === 'object' && data !== null) {
      // Handle objects
      for (const key of Object.keys(data)) {
        const newPrefix = prefix ? `${prefix}.${key}` : key;
        flattenData(data[key], newPrefix);
      }
    } else if (data !== undefined && data !== null) {
      // Handle primitive values
      questions.push(prefix);
      answers.push(data);
    }
  };

  // Process levelData
  flattenData(levelData);

  return { questions, answers };
};

const generateCSVData = (users) => {
  if (!Array.isArray(users)) {
    console.error('generateCSVData: users is not an array:', users);
    throw new Error('Invalid users data: Expected an array');
  }

  // Get all unique questions from all levels across all users
  const allLevelQuestions = {};
  LEVELS.forEach(level => {
    allLevelQuestions[level.key] = new Set();
  });

  // Collect all unique questions for each level
  users.forEach(user => {
    LEVELS.forEach(level => {
      // Deep clean level data to remove _id and id fields
      const levelData = removeIdFields({ ...user[level.key] });
      delete levelData.user;
      delete levelData.createdAt;
      delete levelData.updatedAt;
      const { questions } = getLevelQA(levelData);

      questions.forEach(q => {
        if (q && q.trim() && !shouldExcludeQuestion(q)) {
          // Replace dots with '>' for consistency
          const modifiedQuestion = q.replace(/\./g, '>');
          // Additional check for level 5 to exclude 'strengths' explicitly
          if (level.key === 'level5' && modifiedQuestion.toLowerCase().includes('strengths')) {
            return; // Skip adding strengths-related questions in level 5
          }
          allLevelQuestions[level.key].add(modifiedQuestion);
        }
      });
    });
  });

  // Convert sets to arrays and ensure consistent ordering
  const levelQuestionsArrays = {};
  LEVELS.forEach(level => {
    levelQuestionsArrays[level.key] = Array.from(allLevelQuestions[level.key]).sort();
  });

  // Create base headers, excluding _id and id
  const baseHeaders = [
    'ID',
    'Datum & Uhrzeit',
    ...headers.filter(h => !h.key.toLowerCase().includes('id')).map(h => h.label),
    'Geburtsland',
    'Vater Geburtsland',
    'Mutter Geburtsland',
    'Avatar',
    'Psychiatrischer Behandlung',
    'Psychiatrische Diagnose',
    'Psychologischer Betreuung',
    'Psychotherapie Behandlung',
    'Krankenhaus Betreuung',
    'Diagnosen',
    'Andere Diagnose',
    'Medikamenteneinnahme',
    'Welche Medikamente',
  ];

  // Create level header row
  const levelHeaderRow = [
    ...baseHeaders.map(() => ''),
  ];

  // Create question header row
  const questionHeaderRow = [...baseHeaders];

  // Add level headers and questions
  LEVELS.forEach(level => {
    const questions = levelQuestionsArrays[level.key];
    if (questions.length === 0) {
      levelHeaderRow.push(`*** ${level.label} ***`);
      questionHeaderRow.push('');
    } else {
      questions.forEach((question, index) => {
        if (index === 0) {
          levelHeaderRow.push(`*** ${level.label} ***`);
        } else {
          levelHeaderRow.push('');
        }
        questionHeaderRow.push(question || '');
      });
    }
  });

  // Create data rows
  const dataRows = users.map((user, userIndex) => {
    const userData = removeIdFields({ ...user });

    const baseRow = [
      userIndex + 1,
      userData.createdAt ? format(new Date(userData.createdAt), 'dd/MM/yyyy h:mm a', { locale: de }) : '',
      ...headers.filter(h => !h.key.toLowerCase().includes('id')).map((h) => {
        const value = userData[h.key];
        if (h.key === 'gender') {
          return value === 'MALE'
            ? 'Männlich'
            : value === 'FEMALE'
            ? 'Weiblich'
            : value === 'OTHER'
            ? 'Divers'
            : value === 'UNKNOWN'
            ? 'Unbekannt'
            : '';
        }
        return value || '';
      }),
      userData.birthPlace?.country || '',
      userData.birthPlace?.fatherCountry || '',
      userData.birthPlace?.motherCountry || '',
      userData.avatar || '',
      userData.psychiatricCare || '',
      userData.psychiatricDiagnosis || '',
      userData.psychologicalCare || '',
      userData.psychotherapy || '',
      userData.hospitalCare || '',
      Array.isArray(userData.diagnoses) ? userData.diagnoses.join(', ') : '',
      userData.otherDiagnosis || '',
      typeof userData.isTakingMedication === 'boolean' ? (userData.isTakingMedication ? 'Ja' : 'Nein') : '',
      userData.whichTakeMedication || '',
    ];

    // Add answers for each level
    LEVELS.forEach(level => {
      const levelData = removeIdFields({ ...userData[level.key] });
      delete levelData.user;
      delete levelData.createdAt;
      delete levelData.updatedAt;
      const { questions, answers } = getLevelQA(levelData);
      const levelQuestions = levelQuestionsArrays[level.key];

      if (levelQuestions.length === 0) {
        baseRow.push('');
      } else {
        const questionAnswerMap = {};
        questions.forEach((q, index) => {
          if (!shouldExcludeQuestion(q)) {
            const modifiedQuestion = q.replace(/\./g, '>');
            // Additional check for level 5 to exclude 'strengths'
            if (level.key === 'level5' && modifiedQuestion.toLowerCase().includes('strengths')) {
              return; // Skip strengths-related questions in level 5
            }
            questionAnswerMap[modifiedQuestion] = removeIdFields(answers[index]) || '';
          }
        });

        levelQuestions.forEach(question => {
          baseRow.push(questionAnswerMap[question] || '');
        });
      }
    });

    return baseRow;
  });

  // Combine all rows: level headers, question headers, then data
  const csvData = [levelHeaderRow, questionHeaderRow, ...dataRows];

  return csvData;
};

  return (
    <div className="mt-8">
      <div className="flex justify-between mb-4">
        <h2 className="text-white my-4">Alle gebruikers</h2>
        <button
          onClick={getAllCsv}
          className="button_secodry flex justify-center items-center"
          disabled={loading}
        >
          {loading ? 'Loading...' : 'CSV exportieren'}
        </button>
        {csvData && (
          <CSVLink
            data={csvData}
            filename="user-module-export.csv"
            ref={csvLinkRef}
            className="hidden"
            enclosingCharacter='"'
            separator=","
          />
        )}
      </div>
      <div className="relative rounded-lg border border-white bg-[#1a2341] overflow-hidden">
        <div className="overflow-auto max-h-[90vh]">
          <table className="min-w-full text-base">
            <thead className="sticky top-0 z-10">
              <tr className="bg-[#1a2341]">
                <th className="px-4 py-3 border-b border-gray-300 text-left text-white text-sm font-semibold">ID</th>
                <th className="px-4 py-3 border-b border-gray-300 text-left text-white text-sm font-semibold">Datum & Uhrzeit</th>
                {headers.map((header) => (
                  <th
                    key={header.key}
                    className="px-4 py-3 border-b border-gray-300 text-left text-white text-sm font-semibold"
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 0 ? 'bg-[#18203a]' : 'bg-[#222b48]'}
                  >
                    <td className="px-4 py-3 border-b border-white text-sm text-white">{(page - 1) * 10 + (rowIndex + 1)}</td>
                    <td className="px-4 py-3 border-b border-white text-sm text-white">
                      {row.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy h:mm a', { locale: de }) : ''}
                    </td>
                    {headers.map((header) => (
                      <td
                        key={header.key}
                        className="px-4 py-3 border-b border-white text-sm text-white"
                      >
                        {header.key === 'gender'
                          ? row[header.key] === 'MALE'
                            ? 'Männlich'
                            : row[header.key] === 'FEMALE'
                            ? 'Weiblich'
                            : row[header.key] === 'OTHER'
                            ? 'Divers'
                            : row[header.key] === 'UNKNOWN'
                            ? 'Unbekannt'
                            : ''
                          : row[header.key] || ''}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={headers.length + 2}
                    className="px-4 py-2 text-center text-sm text-gray-500"
                  >
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table; 